export default __webpack_public_path__ + "static/11_23-891afc3e379c77b4195fc81577cc72c1.png";